import { AppHelper } from "../appHelper.js"
import { CommonApp, CommonAppProps, Entity } from "../core/components/commonApp.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import { Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Config } from "../core/config/config.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { ResourcePlanningHelper } from "../core/util/resourcePlanningHelper.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class CreateAssignment extends React.Component<CreateAssignmentAppProps, any> {
    private _prevCodeValue = null;
    private _prevProject = null;
    private _initialAddress = null;
    common = new AppHelper();
    noInitalProjectNo = true;
    translations: StringKeyDictionary<string>;
    flags = {
        addressSearchEnabled: false,
        addressInputEnabled: false,
        projectSearchEnabled: false,
        projectInputEnabled: false
    };
    saveEnabled = true;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.noInitalProjectNo = !Helper.hasValue(props.entity.Project);
        this._initApp();
    }


    private _getHourAndMinute(timeString) {
        var h = null, m = null;
        if (timeString.length === 5) {
            h = parseInt(timeString.substr(0, 2), 10);
            m = parseInt(timeString.substr(3, 2), 10);
        }
        return { h: h, m: m };
    }

    private _updateTime(date, timeString) {
        var time = this._getHourAndMinute(timeString);
        date.setHours(time.h);
        date.setMinutes(time.m);
    }

    private _setAssignmentDefaultDates(customStart, customEnd) {
        let startDateObj = null, endDateObj = null;
        if (this.props.settings.UseTicketDeadline) {
            startDateObj = kendo.parseDate(customStart || this.props.defaultDeadline);
            endDateObj = kendo.parseDate(customEnd || this.props.defaultDeadline);

            if (!customEnd) {
                endDateObj.setDate(endDateObj.getDate()
                    + (typeof this.props.settings.DefaultProjectDays === "number" ?
                        (this.props.settings.DefaultProjectDays > 0 ? this.props.settings.DefaultProjectDays - 1 : this.props.settings.DefaultProjectDays) : 0));
            }
        } else {
            startDateObj = new Date();
            endDateObj = new Date();
        }

        if (!customEnd) {
            this._updateTime(startDateObj, this.props.settings.WorkStartTime);
            this._updateTime(endDateObj, this.props.settings.WorkEndTime);
        }

        MetaDataHelper.setFieldValue(this.props.entity, "entity.StartDate", kendo.toString(startDateObj, "g"));
        MetaDataHelper.setFieldValue(this.props.entity, "entity.EndDate", kendo.toString(endDateObj, "g"));
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        let start: Date | string = null;
        let end: Date | string = null;
        let diff = -1;
        let endIsHigherThanStart = false;

        switch (field.model) {
            case "entity.ResourceAssignment":
                if (value === true) {
                    MetaDataHelper.setReadOnly(this.props.metadata, "entity.Resource", false);
                    MetaDataHelper.setReadOnly(this.props.metadata, "entity.Container", true);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Resource", null);
                } else if (value === false) {
                    MetaDataHelper.setReadOnly(this.props.metadata, "entity.Resource", true);
                    MetaDataHelper.setReadOnly(this.props.metadata, "entity.Container", false);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Container", null);
                }
                if (!isInit) {
                    this.common.validatorHelper.hideMessages();
                }
                break;
            case "entity.ProjectCode":
                this._prevCodeValue = this.props.entity.ProjectCode;
                const prefix = value ? value.substr(0, 2) : "";

                switch (prefix) {
                    case "00":
                        //new project
                        this.flags.addressSearchEnabled = false;
                        this.flags.addressInputEnabled = false;
                        this.flags.projectSearchEnabled = true;
                        this.flags.projectInputEnabled = true;

                        let projectCreated = false;
                        const sheet = General.Sheet.Manager.createSheetWithUrl("Project/New?isWindow=true&initAddress=" + (Helper.hasValue(this.props.entity.Address) ? this.props.entity.Address : ""));
                        sheet.setTitle(this.translations["WebSMS.Ticket.Assignment.CreateProject"]);
                        sheet.bind(SheetEventType.SavedSuccessfully, (ev) => {
                            projectCreated = true;
                            const newProject = ev.entity;
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.Project", newProject.Projnr);
                            this._setAssignmentDefaultDates(newProject.Startsoll, newProject.Endesoll);
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.ProjectCode", "4_" + newProject.Knr);
                            this.setState({});
                        });
                        sheet.bind(SheetEventType.Close, () => {
                            if (!projectCreated) {
                                this.handleFieldChange({ model: "entity.ProjectCode" }, this._prevCodeValue);
                            }
                        });
                        break;
                    case "0_":
                        //existing project
                        this.flags.addressSearchEnabled = false;
                        this.flags.addressInputEnabled = false;
                        this.flags.projectSearchEnabled = true;
                        this.flags.projectInputEnabled = true;
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Address", this._initialAddress);
                        if (this.props.entity.Project === "9999999") {
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.Project", null);
                        }
                        break;
                    case "3_":
                        //address related
                        this.flags.addressSearchEnabled = true;
                        this.flags.addressInputEnabled = true;
                        this.flags.projectSearchEnabled = false;
                        this.flags.projectInputEnabled = false;
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Project", "9999999");
                        var knr = value.substring(value.indexOf("_") + 1);
                        HTTPService.get("ResourcePlanningLookup/GetDefaultAddressForCode?knr=" + knr)
                            .then(result => {
                                if (Helper.hasValue(result) && Helper.hasValue(result.adrnr)) {
                                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Address", result.adrnr);
                                    this.setState({});
                                }
                            });
                        break;
                    case "4_":
                    //project related
                    case "5_":
                        //service
                        this.flags.addressSearchEnabled = false;
                        this.flags.addressInputEnabled = false;
                        this.flags.projectSearchEnabled = true;
                        this.flags.projectInputEnabled = true;
                        if (this.props.entity.Project === "9999999") {
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.Project", null);
                        }
                        break;
                    default:
                        this.flags.addressSearchEnabled = false;
                        this.flags.addressInputEnabled = false;
                        this.flags.projectSearchEnabled = false;
                        this.flags.projectInputEnabled = false;
                        break;
                }
                MetaDataHelper.setRequired(this.props.metadata, "entity.Address", this.flags.addressInputEnabled);
                MetaDataHelper.setRequired(this.props.metadata, "entity.Project", this.flags.projectInputEnabled);

                this.common.validatorHelper.hideMessages();
                break;

            case "entity.StartDate":
                start = Helper.dates.toDate(value);
                end = new Date(this.props.entity.EndDate);

                diff = end.getTime() - new Date(this.props.entity.StartDate).getTime();
                endIsHigherThanStart = (end.getTime() - start.getTime()) <= 0;
                if (endIsHigherThanStart) {
                    const newEnd = Helper.dates.getISODateString(new Date(start.getTime() + diff));
                    this.handleFieldChange({ model: "entity.EndDate" }, newEnd);
                }
                break;

            case "entity.EndDate":
                start = Helper.dates.toDate(this.props.entity.StartDate);
                end = Helper.dates.toDate(value)

                diff = new Date(this.props.entity.EndDate).getTime() - start.getTime();
                endIsHigherThanStart = (end.getTime() - start.getTime()) <= 0;
                if (endIsHigherThanStart) {
                    const newStart = Helper.dates.getISODateString(new Date(end.getTime() - diff));
                    this.handleFieldChange({ model: "entity.StartDate" }, newStart);
                }

                break;

            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    handleIsSearchFieldFullObjectModel = (field, dataItem) => {
        switch (field.model) {
            case "entity.Project":
                this._setAssignmentDefaultDates(dataItem.startist, dataItem.endeist);
                MetaDataHelper.setFieldValue(this.props.entity, "entity.ProjectCode", "4_" + dataItem.knr);
                this._prevProject = this.props.entity.Project;
                this.handleFieldChange(field, dataItem.projnr);
                break;
            default:
                break;
        }
    }

    save = async (openAfterSave) => {
        const checkSla = await ResourcePlanningHelper.checkSla(this.props.entity.StartDate, this.props.entity.Project, null, this.props.entity.Ticket, this.props.entity.Address);
        if (this.common.validate() && checkSla) {
            const data = this.props.entity as any;
            data.StartDate = Helper.dates.getISODateString(data.StartDate);
            data.EndDate = Helper.dates.getISODateString(data.EndDate);

            const result = await HTTPService.post<JsonResultClass>("Procedure/CreateAssignment?fromProject=" + this.props.fromProject, data);
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                if (openAfterSave) {
                    Helper.openInNewBrowserTab(Config.baseUrl + "ResourcePlanningScheduler/Index?adjustStart=true&" + result.AdditionalData.OpenUrl);
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, true);
        }
    }

    private _initApp = () => {
        this._initialAddress = this.props.entity.Address;
        this.props.dataSources.assignmentTypesDS = [{ text: this.translations["Ressource.Ressource"], value: true }, { text: this.translations["Einsatz.Container"], value: false }];

        if (this.props.fromProject === true) {
            MetaDataHelper.setRequired(this.props.metadata, "entity.Ticket", false);
            MetaDataHelper.setVisibility(this.props.metadata, "entity.Ticket", false);
            MetaDataHelper.setVisibility(this.props.metadata, "entity.ProjectCode", false);
        }

        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            if (data.cmd == "assignToMe" && !Helper.isNullOrEmpty(Config.user.ressNr)) {
                this.handleFieldChange({ model: "entity.Resource" }, Config.user.ressNr);
            }
        })
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return <CommonApp {...props} />;
    }
};

export interface CreateAssignmentAppProps extends CommonAppProps {
    entity: EntityCreateAssignment;
    defaultDeadline: string;
    settings: {
        DefaultProjectDays: string | number;
        UseTicketDeadline: boolean;
        UserResource: string;
        WorkStartTime: Date;
        WorkEndTime: Date;
    };
    dataSources: {
        assignmentTypesDS: Array<any>;
    }
    fromProject: boolean;
}

interface EntityCreateAssignment extends Entity {
    ProjectCode: string;
    Address: string;
    Project: string;
    ResourceAssignment: string;
    Ticket: number;
    StartDate: Date;
    EndDate: Date;
    TargetTime: number;
    FixStart: boolean;
    FixEnd: boolean;
    GroupId: number;
    MaschNr?: string;
}